import React from "react";
import AnalyticsMiniCard from "../cards/AnalyticsMiniCard";
import { FiUsers, FiUser, FiBriefcase, FiCreditCard } from "react-icons/fi";

const AudienceSummary = ({ summary }) => {
    const cards = [
        { title: "Total Visitors", value: summary?.total_visitors || 0, icon: <FiUsers />, color: "indigo" },
        { title: "Guest Visitors", value: summary?.guest_visitors || 0, icon: <FiUser />, color: "blue" },
        { title: "Artist Accounts", value: summary?.artists || 0, icon: <FiUser />, color: "green" },
        { title: "Organizations", value: summary?.organizations || 0, icon: <FiBriefcase />, color: "orange" },
        { title: "Paying Visitors", value: summary?.converted_visitors || 0, icon: <FiCreditCard />, color: "emerald" },
    ];

    return (
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-3 xl:grid-cols-5">
            {cards.map((card) => (
                <AnalyticsMiniCard key={card.title} {...card} />
            ))}
        </div>
    );
};

export default AudienceSummary;